import { render, staticRenderFns } from "./Ciudades.vue?vue&type=template&id=408c5616&scoped=true&"
import script from "./Ciudades.vue?vue&type=script&lang=js&"
export * from "./Ciudades.vue?vue&type=script&lang=js&"
import style0 from "./Ciudades.vue?vue&type=style&index=0&id=408c5616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c5616",
  null
  
)

export default component.exports